export default __webpack_public_path__ + "static/media/Practitioner_Master.896901aa.svg";